import { connect } from 'react-redux'
import SchoolImport from './school-import'
import {
  getSchoolData,
  isSchoolConnected,
  isSchoolPending,
  isSchoolNotConnected,
  isSchoolPulling,
  isSchoolFinished,
  isSchoolInWonde,
  getConnectSchoolRequest,
  getDisconnectSchoolRequest,
  getPullSchoolRequest,
  isSchoolUsingGroupCall
} from '../../../../../stores/school-data/school-data.selectors'

const mapStateToProps = state => {
  const school = getSchoolData(state)
  const pending =
    getConnectSchoolRequest(state).pending ||
    getDisconnectSchoolRequest(state).pending ||
    getPullSchoolRequest(state).pending
  return {
    id: school.id,
    title: school.title,
    pending: pending,
    connected: isSchoolConnected(state) || isSchoolPending(state),
    notConnected: isSchoolNotConnected(state) || !isSchoolUsingGroupCall(state),
    pulling: isSchoolPulling(state),
    finished: isSchoolFinished(state),
    notInWonde: !isSchoolInWonde(state),
    usingGroupCall: isSchoolUsingGroupCall(state)
  }
}

export default connect(
  mapStateToProps,
  null
)(SchoolImport)
